import { styled } from '@mui/system'
import { PieChart } from 'recharts'

export const RePieChart = styled(PieChart)`
  & .recharts-sector {
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  & .recharts-pie-sector {
    cursor: pointer;

    &:focus {
        outline:none;
    }
  }
  
  & .recharts-layer {
    cursor: pointer;
  }
  
  & .recharts-sector:hover {
    filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.1));
  }

`
